<template>
 <div class="w-full h-full custom-content mt-0 " :class="{'h-full': isDesktop}">
    <div class="header-modal">
      <feather-icon @click.stop="$emit('close')"  icon='ChevronLeftIcon' svgClasses='' class='custom-content-icon menu-icon' v-if="!isDesktop && displayCloseBtn"/>
      <feather-icon  icon="XIcon" @click.stop="$emit('close')" class="cursor-pointer close-icon-customizer" v-if="isDesktop && displayCloseBtn"></feather-icon>
    </div>
    <div class="h-full items-center" style="text-align: center; padding: 0px 30px;">
        <p><feather-icon icon="LockIcon" class="cursor-pointer custom-content-lock-icon mb-4" /></p>
        <p>{{ $t('PRIVATE_CONTENT').Exclusive_Subscribers }}</p>
        <p>{{ $t('PRIVATE_CONTENT').Sign_Up_access }}</p>
        <vs-button class="btn-login" @click.stop="$emit('open-register')">{{ $t('PRIVATE_CONTENT').Register }}</vs-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isDesktop: {
      require: true
    },
    displayCloseBtn: {
    default: true
    }
  },
  data() {
    return {
      settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.3,
          swipeEasing: true
        },
    };
  },
  watch: {
  },
  computed: {
    featherIconSize() {
      if (this.isDesktop) {
        return "h-8 w-8";
      } else {
        return "h-6 w-6";
      }
    },
  },
  methods: {
  }
};

</script>

